<template>
  <SBreadcrumbsSeo
    :breadcrumbs="[
      { label: 'Home', href: ziggy('mainSite.homepage') },
      {
        label: geoProductCategory?.name ?? routeParams.geoProductSlug,
        href: ziggy('client.slug', { slug: routeParams.geoProductSlug }),
      },
      {
        label: province?.name ?? routeParams.province,
        href: ziggy('mainSite.localSearch.province', routeParams),
      },
      {
        label: municipality?.name ?? routeParams.municipality,
        href: ziggy('mainSite.localSearch.municipality', routeParams),
      },
      { label: customerName },
    ]"
  />
</template>

<script setup lang="ts">
import { injectI18nLocale } from "@solvari/translations";

import { ziggy } from "@/shared/libs/ziggy";
import { useLocalSearchData } from "~/features/company-wall/composables/useLocalSearch";
import SBreadcrumbsSeo from "~/shared/components/SBreadcrumbsSeo.vue";

const props = defineProps<{
  customerName: string;
  routeParams: {
    geoProductSlug: string;
    municipality: string;
    province: string;
  };
}>();

const localeCode = injectI18nLocale().value;

const { geoProductCategory, province, municipality } = useLocalSearchData({
  ...props.routeParams,
  localeCode,
});
</script>
